<div *ngIf="initialized && length && numberOfPages >= 1" class="flex flex-row justify-between items-center paginator h-60 user-select-none">
  <div class="flex flex-row items-center">
    {{ 'PAGINATOR.ITEMS_PER_PAGE' | transloco }}
    <div class="form-field">
      <select [(ngModel)]="pageSize" (change)="pageSizeChanged()">
        <option *ngFor="let pageSizeOption of pageSizeOptions" [ngValue]="pageSizeOption">{{ pageSizeOption }}</option>
      </select>
    </div>
  </div>
  <div class="flex flex-row items-center">
    <mat-icon svgIcon="first_page" class="icon-md-1" [ngClass]="{'disabled' : pageIndex === 0}" (click)="pageIndex !== 0 && goToPage(0)"></mat-icon>
    <mat-icon svgIcon="chevron_left" class="icon-md-1" [ngClass]="{'disabled' : pageIndex === 0}" (click)="pageIndex !== 0 && goToPage(pageIndex - 1)"></mat-icon>

    <ng-container *ngIf="range[0] !== 0">
      <div class="page-number" [ngClass]="{'active' : pageIndex === 0}" (click)="goToPage(0)">1</div>
      <div class="page-number-delimiter">...</div>
    </ng-container>

    <div *ngFor="let page of range" class="page-number" [ngClass]="{'active' : pageIndex === page}" (click)="goToPage(page)">{{ page + 1 }}</div>

    <ng-container *ngIf="range[range.length - 1] !== numberOfPages - 1">
      <div class="page-number-delimiter">...</div>
      <div class="page-number" [ngClass]="{'active' : pageIndex === numberOfPages - 1}" (click)="goToPage(numberOfPages - 1)">{{ numberOfPages }}</div>
    </ng-container>

    <mat-icon svgIcon="chevron_right" class="icon-md-1" [ngClass]="{'disabled' : pageIndex === numberOfPages - 1}"
      (click)="pageIndex !== numberOfPages - 1 && goToPage(pageIndex + 1)"></mat-icon>
    <mat-icon svgIcon="last_page" class="icon-md-1" [ngClass]="{'disabled' : pageIndex === numberOfPages - 1}"
    (click)="pageIndex !== numberOfPages - 1 && goToPage(numberOfPages - 1)"></mat-icon>
  </div>
</div>

